<aside class="transition-all duration-300" [class]="isCollapsed ? 'w-[64px] sidebar-collapsed' : 'w-[250px]'"
  class="block bg-black dark:bg-dark-sidebar no-print shadow-sidebar h-full">
  <div class="flex flex-col h-full min-h-0">
    <button class="toggle-button flex items-center justify-center cursor-pointer" (click)="toggleSidebar()">
      <lucide-icon [name]="isCollapsed ? 'chevron-right' : 'chevron-left'" class="text-white w-4 h-4">
      </lucide-icon>
    </button>

    <nav class="sidebar-nav-scroll flex flex-col w-full flex-1 min-h-0 justify-start mt-1 mb-2">
      <div class="sidebar-nav-inner px-4">
      @if (haveAccess(navigation[0])) {
      <div class="category-container">
        <div class="category-content-area">
          <div class="w-full mb-1">
            <a class="sidebar-item flex items-center" (click)="onNavigationClick(navigation[0])"
              [class.justify-center]="isCollapsed" [matTooltip]="isCollapsed ? 'Home' : ''" matTooltipPosition="right"
              [matTooltipClass]="'sidebar-tooltip mat-tooltip-panel-showing bg-[#2A2A2A]'" [matTooltipShowDelay]="0"
              [matTooltipHideDelay]="0">
              <lucide-icon name="home" class="text-white w-5 h-5"></lucide-icon>
              @if (!isCollapsed) {
              <span class="text-white text-sm font-medium ml-3">Home</span>
              }
            </a>
          </div>
        </div>
      </div>
      }

      <!-- <div class="my-0 border-b border-white/20"></div> -->

      @for (section of getNavigationSections(); track section.category) {
      <div class="category-container">
        @if (!isCollapsed) {
        <div class="category-header-content">
          <lucide-icon [name]="getCategoryIcon(section.category)" class="category-icon"></lucide-icon>
          <span class="category-title">
            {{ getCategoryTitle(section.category) }}
          </span>
        </div>
        }

        <div class="category-content-area">
        <!-- Subcategory Groups -->
        @for (subCategoryGroup of section.subCategoryGroups; track subCategoryGroup.subCategoryTitle) {
        @if (subCategoryGroup.items.length > 0) {
        <div class="mb-2">
          @if (!isCollapsed) {
          <div class="subcategory-header-wrapper">
            <div class="subcategory-header-content cursor-pointer"
              (click)="toggleSubCategory(subCategoryGroup.subCategoryTitle)">
              <span class="subcategory-title">
                {{ subCategoryGroup.subCategoryTitle }}
              </span>
              <!-- <lucide-icon [name]="isSubCategoryCollapsed(subCategoryGroup.subCategoryTitle, subCategoryGroup.items) ? 'chevron-down' : 'chevron-up'"
                class="subcategory-chevron"></lucide-icon> -->
            </div>
          </div>
          }

          <!-- Show items if not collapsed (auto-expand if has active item) -->
          @if (!isSubCategoryCollapsed(subCategoryGroup.subCategoryTitle, subCategoryGroup.items)) {
          @for (nav of subCategoryGroup.items; track nav.name) {
          @if (haveAccess(nav)) {
          <div class="w-full mb-1">
            <a class="sidebar-item flex items-center subcategory-item" [class.justify-center]="isCollapsed"
              [class.active]="isActive(nav.routes)" (click)="onNavigationClick(nav)"
              [matTooltip]="isCollapsed ? nav.name : ''" matTooltipPosition="right"
              [matTooltipClass]="'sidebar-tooltip mat-tooltip-panel-showing bg-[#2A2A2A]'" [matTooltipShowDelay]="0"
              [matTooltipHideDelay]="0">
              <lucide-icon [name]="nav.icon" class="text-white w-5 h-5"></lucide-icon>
              @if (!isCollapsed) {
              <span class="text-white text-sm font-medium ml-3 whitespace-nowrap">{{ nav.name }}</span>
              }
            </a>
          </div>
          }
          }
          }
        </div>
        }
        }

        <!-- Items without subcategory -->
        @if (section.itemsWithoutSubCategory.length > 0) {
        @for (nav of section.itemsWithoutSubCategory; track nav.name) {
        @if (haveAccess(nav)) {
        <div class="w-full mb-1">
          <a class="sidebar-item flex items-center" [class.justify-center]="isCollapsed"
            [class.active]="isActive(nav.routes)" (click)="onNavigationClick(nav)"
            [matTooltip]="isCollapsed ? nav.name : ''" matTooltipPosition="right"
            [matTooltipClass]="'sidebar-tooltip mat-tooltip-panel-showing bg-[#2A2A2A]'" [matTooltipShowDelay]="0"
            [matTooltipHideDelay]="0">
            <lucide-icon [name]="nav.icon" class="text-white w-5 h-5"></lucide-icon>
            @if (!isCollapsed) {
            <span class="text-white text-sm font-medium ml-3 whitespace-nowrap">{{ nav.name }}</span>
            }
          </a>
        </div>
        }
        }
        }
        </div>
      </div>
      }
      </div>
    </nav>
  </div>
</aside>
